import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Select,
  TextField,
  Box,
  IconButton,
  Modal,
  InputAdornment,
  Snackbar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../css/report.css";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Global from "../utils/global";
import { DateTime } from "luxon";
import LoadingCustomButton from "../components/LoadingCustomButton";
import ReactLoading from "react-loading";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


const HistoryDetailsModal = ({
  open,
  setOpen,
  patient_info,
  history_id
}: any) => {
  const navigate = useNavigate();

  const [loadingDetails, setLoadingDetails] = useState(true);
  const [selectedNodes, setSelectedNodes] = useState([]);

  const getDetails = async () => {
    setLoadingDetails(true);
    const data = await Global.httpGET(`disease/history/${history_id}`);
    console.log(data);
    if (data && !data.isError) {
      if (data.selectedNodes) {
        setSelectedNodes(data.selectedNodes);
        // setPatientInfo(patientInfo);
      }
    }
    setLoadingDetails(false);
  };

  useEffect(()=>{
    if(open) getDetails();
  }, [open])

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div className="flowchart-summary-modal-overlay">
        <div className="flowchart-summary-modal">
          <div className="summary-header">
            <div style={{ flexDirection: "row", display: "flex" }}>
              <Typography className="header-text">History Details</Typography>
            </div>
            <div className="column-2">
              <IconButton
                aria-label="close"
                style={{ alignSelf: "baseline" }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon className="close-btn" />
              </IconButton>
            </div>
          </div>
          <div className="body">
            <div>
              <div className="patient_info">
                <Typography>
                  Name: {patient_info.name}
                </Typography>
                <Typography>
                  Age: {patient_info.age}
                </Typography>
                <Typography>
                  City: {patient_info.city}
                </Typography>
                {/* <input
                  className="name"
                  placeholder="Patient's Name"
                  type="text"
                  name="name"
                  onChange={(event: any) => {
                    // console.log({ id: event.target.value });
                    setPatientInfo({
                      ...patientInfo,
                      name: event.target.value,
                    });
                  }}
                /> */}
                {/* <input
                  className="age"
                  placeholder="Age"
                  type="number"
                  min={4}
                  name="age"
                  onChange={(event: any) => {
                    // console.log({ name: event.target.value });
                    setPatientInfo({
                      ...patientInfo,
                      age: event.target.value,
                    });
                  }}
                  //   value={name}
                /> */}
                {/* <select
                  className="city"
                  placeholder="City"
                  onChange={(event: any) => {
                    // console.log({ name: event.target.value });
                    setPatientInfo({
                      ...patientInfo,
                      city: event.target.value,
                    });
                  }}
                  // onChangeCapture={(e) => console.log(e)}
                  value={patientInfo.city}
                >
                  <option value="null" disabled>
                    City
                  </option>
                  {cities.map((city: any, index) => (
                    <option key={index} value={city.value}>
                      {city.label}
                    </option>
                  ))}
                </select> */}
              </div>
              {
                loadingDetails?
                <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <ReactLoading
              type="bubbles"
              color={"black"}
              height={50}
              width={50}
            />
          </div>:

              
              <div className="summary">
                {selectedNodes.map((data: any, index: number) => (
                  <div className="data-container" key={index}>
                    <div
                      className="label-container"
                      onClick={() => {
                        //   setExpanded(
                        //      expanded === data.id ? false : data.id
                        //   );
                      }}
                    >
                      <span className="icon-container">
                        {/* <Check className="icon" /> */}
                      </span>
                      <span
                        style={{
                          display: "flex",
                          flex: 1,
                          marginLeft: "10px",
                          flexDirection: "column",
                        }}
                      >
                        {data.data.label
                          .split("\\n")
                          .map((ele: string, index: any) => (
                            <Typography className="label" key={index}>
                              {ele}
                            </Typography>
                          ))}
                      </span>
                    </div>
                    {/* {expanded === data.id ? ( */}
                    <div className="description-container">
                    {data.data.description
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Typography
                                          className="description"
                                          key={index}
                                       >
                                          {ele}
                                       </Typography>
                                    ))}
                    </div>
                    {/* ) : null} */}
                  </div>
                ))}
              </div>
}
            </div>
            <div className="footer">
              <div>
                <LoadingCustomButton
                  sx={{ marginRight: "20px" }}
                  disabled={loadingDetails}
                  onClick={() => {
                    navigate("/summaryPDF", {
                      state: {
                        selectedNodes,
                        previousScreen: "diagnose",
                        patientInfo: patient_info,
                      },
                    });
                  }}
                >
                  <Typography className="btn-text">
                    {/* <Link
                                 to="/summaryPDF"
                                 // target="_blank"
                                 rel="noreferrer"
                                 // style={{
                                 //    textDecoration: "none",
                                 //    color: "white",
                                 // }}
                                 className="btn-text"
                                 state={{
                                    selectedNodes,
                                    previousScreen: "diagnose",
                                 }}
                              > */}
                    Export to PDF
                    {/* </Link> */}
                  </Typography>
                </LoadingCustomButton>
              </div>
              <div>
                {/* <LoadingCustomButton>
                           <Typography className="btn-text">Copy</Typography>
                        </LoadingCustomButton> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const ReportRow = ({
  internInfo,
  patientInfo,
  date,
  history_id,
  selectedNodes,
  loadingDetails,
}: any) => {
  const [historyModal, setHistoryModal] = useState(false);
  const [LoadingDetails, setLoadingDetails] = useState(loadingDetails);
  const [SelectedNodes, setSelectedNodes] = useState(selectedNodes);
  const [PatientInfo, setPatientInfo] = useState(patientInfo);

  const getDetails = async (history_id: any, patientInfo: any) => {
    setLoadingDetails(true);
    const data = await Global.httpGET(`disease/history/${history_id}`);
    console.log(data);
    if (data && !data.isError) {
      if (data.selectedNodes) {
        setSelectedNodes(data.selectedNodes);
        setPatientInfo(patientInfo);
      }
    }
    setLoadingDetails(false);
  };

  return (
    <>
      <div className="report-table-container">
        <div
          className="report-table-row"
          onClick={() => {
            setHistoryModal(true);
          }}
        >
          <Typography
            className="report-table-row-text"
            style={{ width: "20%", marginLeft: "20px" }}
          >
            {internInfo.id}
          </Typography>
          <Typography
            className="report-table-row-text"
            style={{ width: "25%" }}
          >
            {internInfo.name}
          </Typography>
          <Typography
            className="report-table-row-text"
            style={{ width: "25%" }}
          >
            {patientInfo.name}
          </Typography>
          <Typography
            className="report-table-row-text"
            style={{ width: "12%" }}
          >
            {patientInfo.city}
          </Typography>
          <Typography
            className="report-table-row-text"
            style={{ width: "12%" }}
          >
            {DateTime.fromJSDate(new Date(date)).toFormat("MMM dd, yyyy")}
          </Typography>
          {/* <IconButton onClick={() => {
            navigate("/summaryPDF", {
              state: {
                selectedNodes,
                previousScreen: "report",
                patientInfo,
              },
            });
          }}>
            <PictureAsPdfIcon className="report-pdf-icon" />
          </IconButton> */}
        </div>
      </div>
      <HistoryDetailsModal open={historyModal} setOpen={setHistoryModal} patient_info={patientInfo} history_id={history_id} />
    </>
  );
};

interface filtersProps {
  text: string;
  date: any;
  city: string;
}

const Report = () => {
  const [histories, setHistories]: any = useState();
  const [filteredHistory, setFilteredHistory]: any = useState();
  const [selectedNodes, setSelectedNodes]: any = useState();
  const [patientInfo, setPatientInfo]: any = useState();
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [searchText, setSearchText]: any = useState("");
  const [cities, setCities]: any = useState([]);
  const [dates, setDates]: any = useState([]);
  const [texts, setTexts]: any = useState([]);
  const [filters, setFilters] = useState<filtersProps>({
    text: "",
    date: "",
    city: "null",
  });

  const getAllHistory = async () => {
    setLoadingList(true);
    const data = await Global.httpGET("disease/history/get/all");
    console.log(data);
    if (data && !data.isError) {
      if (data.histories) {
        setHistories(data.histories);
        setFilteredHistory(data.histories);
      }
    }
    setLoadingList(false);
  };

  const handleSearch = () => {
    if (filters.city === "null" && filters.date === "" && filters.text === "") {
      return;
    }
    // const data =
  };

  // const handleSearch = (string: any) => {
  //   if (!histories) {
  //     return;
  //   }
  //   if (string === "") {
  //     return setFilteredHistory(histories);
  //   }
  //   let filter;
  //   if (typeof string === "object") {
  //     filter = histories.filter((data: any) => {
  //       let cre_date = DateTime.fromISO(data.created_on).toFormat("dd MMM yy");
  //       return cre_date === DateTime.fromISO(searchText).toFormat("dd MMM yy");
  //     });
  //   } else {
  //     filter = histories.filter((data: any) => {
  //       return (
  //         data.disease.name.toLowerCase().includes(string.toLowerCase()) ||
  //         data.user.name.toLowerCase().includes(string.toLowerCase()) ||
  //         data.user.id.toLowerCase().includes(string.toLowerCase())
  //       );
  //     });
  //   }

  //   setFilteredHistory(filter);
  // };

  // const getCities = async () => {
  //   const data = await Global.httpGET("disease/static/cities");
  //   console.log(data);
  //   if (data) {
  //     setCities(data.cities);
  //     Global.cities = data;
  //   }
  // };

  const getCities = async () => {
    const data = await Global.httpGET("static/cities");
    if (data) {
      setCities(data);
      Global.cities = data;
    }
  };

  const handleFilter = async () => {
    setLoadingList(true);
    console.log({ filters });
    if (filters.city === "null" && filters.date === "" && filters.text === "") {
      return setHistories();
    }
    const data = await Global.httpGET(
      `disease/history/get/filter?text=${filters.text}&date=${filters.date}&city=${filters.city}`
    );
    console.log(data);
    if (data) {
      setHistories(data.histories);
    }
    setLoadingList(false);
  };

  useEffect(() => {
    // if (!histories) getAllHistory();
    if (!cities[0] && Global.token) {
      getCities();
      // getAllHistory();
    }
  }, []);

  const onClick = () => {
    alert("Calendar clicked!");
  };

  return (
    <div className="reportScreen">
      <div className="report-search">
        <input
          className="search-box"
          placeholder="Type here"
          onChange={(event: any) => {
            // console.log({ name: event.target.value });
            setFilters({
              ...filters,
              text: event.target.value,
            });
            setTexts({ ...texts, text: event.target.value });
          }}
        />
        <select
          className="city-dropdown"
          placeholder="City"
          onChange={(event: any) => {
            // console.log({ name: event.target.value });
            setFilters({
              ...filters,
              city: event.target.value,
            });
          }}
          // onChangeCapture={(e) => console.log(e)}
          value={filters.city}
        >
          <option value="null">City</option>
          {cities.map((city: any, index: any) => (
            <option key={index} value={city.value}>
              {city.label}
            </option>
          ))}
        </select>
        {/* <TextField
          className="search-by-date"
          // id="outlined-basic"
          size="small"
          placeholder="Type here"
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarTodayIcon className="cal" onClick={onClick} />
              </InputAdornment>
            ),
          }}
        /> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Custom input"
            value={filters.date}
            onChange={(newValue: any) => {
              setFilters({ ...filters, date: newValue.$d });
              setDates({ ...dates, date: newValue.$d });
              // Data.date = newValue.$d;
            }}
            maxDate={new Date()}
            renderInput={({ inputRef, inputProps, InputProps }) => (
              <div
                className="search-by-date"
                ref={inputRef}
                onClick={
                  (InputProps as any)?.endAdornment?.props?.children?.props
                    ?.onClick
                }
              >
                <Typography className="date">
                  {filters.date
                    ? DateTime.fromJSDate(filters.date).toFormat("MMM dd, yyyy")
                    : "Date"}
                </Typography>
                <CalendarTodayIcon className="icon" />
              </div>
            )}
          />
        </LocalizationProvider>
        <LoadingCustomButton
          className="search-button"
          loading={false}
          variant="contained"
          onClick={handleFilter}
        >
          <Typography className="search-button-text">Search</Typography>
        </LoadingCustomButton>
      </div>
      <div className="report-table">
        <div className="report-table-header">
          <Typography
            className="report-table-header-text"
            style={{ width: "20%", marginLeft: "20px" }}
          >
            Intern's ID
          </Typography>
          <Typography
            className="report-table-header-text"
            style={{ width: "25%" }}
          >
            Intern's Name
          </Typography>
          <Typography
            className="report-table-header-text"
            style={{ width: "25%" }}
          >
            Patient's Name
          </Typography>
          <Typography
            className="report-table-header-text"
            style={{ width: "12%" }}
          >
            Patient's City
          </Typography>
          <Typography
            className="report-table-header-text"
            style={{ width: "12%" }}
          >
            Date
          </Typography>
        </div>
        {loadingList ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <ReactLoading
              type="bubbles"
              color={"black"}
              height={50}
              width={50}
            />
          </div>
        ) : histories && histories[0] ? (
          histories.map((data: any, index: any) => (
            <ReportRow
              key={index}
              internInfo={{ name: data.user.name, id: data.user.id }}
              patientInfo={data.patient_info}
              date={data.created_on}
              history_id={data.id}
              selectedNodes={selectedNodes}
              loadingDetails={loadingDetails}
            />
          ))
        ) : // texts[0]

        histories ? (
          // dates[0]
          <Typography
            style={{
              fontFamily: "Nunito",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              fontWeight: "bold",
              margin: "12px 0px",
            }}
          >
            Data not found
          </Typography>
        ) : (
          <Typography
            style={{
              fontFamily: "Nunito",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              fontWeight: "bold",
              margin: "12px 0px",
            }}
          >
            Please filter reports as per your need.
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Report;

{
  /* <div className="reportScreen">
         <Box className="left-box">
            <div className="report-search">
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                     label="Date desktop"
                     inputFormat="MM/DD/YYYY"
                     value={searchText}
                     onChange={(date) => {
                        // console.log(DateTime.fromJSDate(date.$d));
                        setSearchText(DateTime.fromJSDate(date.$d));
                     }}
                     renderInput={(params) => {
                        return (
                           <TextField
                              className="search-box"
                              // id="outlined-basic"
                              size="small"
                              placeholder="Type here"
                              value={
                                 typeof searchText === "object"
                                    ? DateTime.fromISO(searchText).toFormat(
                                         "dd MMM yy"
                                      )
                                    : searchText
                              }
                              onChange={(e) => setSearchText(e.target.value)}
                              InputProps={params.InputProps}
                              // inputProps={params.inputProps}
                              // inputRef={(ref) => console.log({ ref })}
                              inputRef={params.inputRef}
                           />
                        );
                     }}
                  />
               </LocalizationProvider>
               {/* <TextField
                  className="search-box"
                  // id="outlined-basic"
                  size="small"
                  placeholder="Type here"
                  onChange={(e) => setSearchText(e.target.value)}
                  InputProps={{
                     endAdornment: (
                        <InputAdornment position="end">
                           <CalendarTodayIcon
                              className="cal"
                              onClick={onClick}
                           />
                        </InputAdornment>
                     ),
                  }}
               /> */
}
//          <LoadingCustomButton
//             className="search-button"
//             onClick={() => handleSearch(searchText)}
//          >
//             <SearchIcon style={{ color: "var(--buttonText)" }} />
//          </LoadingCustomButton>
//       </div>
//       {loadingList ? (
//          <div
//             style={{
//                display: "flex",
//                flexDirection: "row",
//                justifyContent: "center",
//             }}
//          >
//             <ReactLoading
//                type="bubbles"
//                color={"black"}
//                height={100}
//                width={100}
//             />
//          </div>
//       ) : (
//          <>
//             {filteredHistory &&
//                filteredHistory.map((data: any, index: any) => (
//                   <Box
//                      className="details"
//                      onClick={() =>
//                         getDetails(data.id, data.patient_info)
//                      }
//                      key={index}
//                   >
//                      <div className="left-container">
//                         <Typography className="disease">
//                            {data.disease.name}
//                         </Typography>
//                         <ArrowForwardIosIcon className="arrow" />
//                      </div>
//                      <div className="right-container">
//                         <Typography className="user-info">
//                            {data.user.name} | {data.user.id}
//                         </Typography>
//                         <Typography className="date">
//                            {DateTime.fromISO(data.created_on).toFormat(
//                               "dd MMM yy"
//                            )}
//                         </Typography>
//                      </div>
//                   </Box>
//                ))}
//          </>
//       )}
//    </Box>
//    {selectedNodes && patientInfo && (
//       <HistoryDetails
//          selectedNodes={selectedNodes}
//          patientInfo={patientInfo}
//          isLoading={loadingDetails}
//       />
//    )}
//    {/* <SummaryModal /> */}
// </div> */}

// const HistoryDetails = ({ selectedNodes, patientInfo, isLoading }: any) => {
//    const navigate = useNavigate();

//    return (
//      <Modal open={open} handleClose={close}>
// //        <div className="history-details">
// {
//   /* {isLoading ? (
//          <div
//            style={{
//              display: "flex",
//              flexDirection: "row",
//              justifyContent: "center",
//            }}
//          >
//            <ReactLoading
//              type="bubbles"
//              color={"black"}
//              height={100}
//              width={100}
//            />
//          </div>
//        ) : ( */
// }
// // <>
// //   <div
// //     style={{
// //       display: "flex",
// //       flexDirection: "row",
// //       justifyContent: "space-between",
// //     }}
// //   >
// //     <Typography className="heading">Details</Typography>
// //     <IconButton
// //       aria-label="close"
// //       style={{ alignSelf: "baseline" }}
// //       onClick={() => {
// //         setOpenS(false);
// //         close();
// //       }}
// //     >
// //       <CloseIcon className="close-btn" />
// //     </IconButton>
// {
//   /* <LoadingCustomButton
//                sx={{ marginRight: "20px" }}
//                onClick={() => {
//                  if (!selectedNodes || !patientInfo) {
//                    return;
//                  }
//                  navigate("/summaryPDF", {
//                    state: {
//                      selectedNodes,
//                      previousScreen: "diagnose",
//                      patientInfo,
//                    },
//                  });
//                }}
//              >
//                <Typography className="btn-text">Export to PDF</Typography>
//              </LoadingCustomButton> */
// }
// //   </div>
// //   <div className="body">
// //     <div>
// //       <Typography className="name">
// //         Patient Name: {patientInfo.name}
// //       </Typography>
// //       <Typography className="age">Age: {patientInfo.age} </Typography>
// //     </div>
// //     <div className="summary">
// //       <Typography className="heading">Summary</Typography>
// //       {selectedNodes.map((data: any, index: number) => (
// //         <div className="data-container" key={index}>
// //           <div
// //             className="label-container"
// //             onClick={() => {
// //               //   setExpanded(
// //               //      expanded === data.id ? false : data.id
// //               //   );
// //             }}
// //           >
// //             <span className="icon-container">
// {
//   /* <Check className="icon" /> */
// }
// //                      </span>
// //                      <span
// //                        style={{
// //                          display: "flex",
// //                          flex: 1,
// //                          marginLeft: "10px",
// //                          flexDirection: "column",
// //                        }}
// //                      >
// //                        {data.data.label
// //                          .split("\\n")
// //                          .map((ele: string, index: any) => (
// //                            <Typography className="label" key={index}>
// //                              {ele}
// //                            </Typography>
// //                          ))}
// //                      </span>
// //                    </div>
// //                    {/* {expanded === data.id ? ( */}
// //                    <div className="description-container">
// //                      <Typography className="description">
// //                        {data.data.description}
// //                      </Typography>
// //                    </div>
// //                    {/* ) : null} */}
// //                  </div>
// //                ))}
// //              </div>
// //            </div>
// //          </>
// //          {/* )} */}
// //        </div>
//      </Modal>
//    );
//  };
